import { render, staticRenderFns } from "./ViewAuditStudySetting.vue?vue&type=template&id=dc54ceb0&scoped=true"
import script from "./ViewAuditStudySetting.vue?vue&type=script&lang=js"
export * from "./ViewAuditStudySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc54ceb0",
  null
  
)

export default component.exports